// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import PageTitle from '@bit/atd.web.page-title'
import MembershipContainer from 'modules/profile/components/Membership'
import PageWrapper from 'modules/profile/components/PageWrapper'

/**
 * 5.0.3 Profile - Membership
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 */

type PropsType = any

const Membership = (props: PropsType): ReactElement => {
  return (
    <PageWrapper>
      <DocumentTitle title={`Profile - Membership Details | ATD`}>
        <>
          <PageTitle>Membership</PageTitle>
          <MembershipContainer />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Membership
